@if (appearance === 'default') {
    <div class="DC--card flex flex-column justify-content-between h-full">
        <div class="header-kpi mb-3">
            <span class="header--title"> {{ kpiTitle }} </span>
            <span class="header--subtitle"> {{ kpiSubtitle }} </span>
            @if (showInfoIcon) {
                <span class="material-symbols-outlined icon-sm cursor-help" pTooltip="{{ contentInfoIcon }}">info</span>
            }
        </div>
        <div class="content flex align-items-baseline">
            <span class="content-value mr-1"> {{ kpiValue }} </span>
            <div class="flex justify-content-between flex-grow-1">
                <span class="content-unit align-self-end"> {{ kpiUnit }} </span>
                @if (showLink) {
                    <a class="content-link text-link align-self-end text-right" href="">{{
                        'results.kpi2.learnMore' | translate
                    }}</a>
                }
            </div>
        </div>
    </div>
}
@if (appearance === 'compact') {
    <div class="equivalence-container flex align-items-center">
        <div class="equivalence flex align-items-center">
            <span class="material-symbols-outlined icon-lg equivalence-icon mr-2" aria-hidden="true">flight</span>
            <div class="equivalence-text">
                <span class="equivalence-value">{{ kpiPlaneValue }}</span>
                <span class="equivalence-label flex align-items-center"
                    >Paris<span class="material-symbols-outlined icon-sm mx-1" aria-hidden="true">sync_alt</span
                    >NYC</span
                >
            </div>
        </div>
        <div class="equivalence flex align-items-center">
            <span class="material-symbols-outlined icon-lg equivalence-icon mr-2" aria-hidden="true">forest</span>
            <div class="equivalence-text">
                <span class="equivalence-value">{{ kpiTreeValue }}</span>
                <span class="equivalence-label">{{ 'results.kpi1.equivalence.treesAmount' | translate }}</span>
            </div>
        </div>
        <div class="equivalence flex align-items-center">
            <span class="material-symbols-outlined icon-lg equivalence-icon mr-2" aria-hidden="true"
                >local_gas_station</span
            >
            <div class="equivalence-text">
                <span class="equivalence-value">{{ kpiFillUpValue }}</span>
                <span class="equivalence-label">{{ 'results.kpi1.equivalence.refueling' | translate }}</span>
            </div>
        </div>
    </div>
}
